import { getMessages } from '../../../../../../store/constants';

export const KANBAN_POLL_QUESTIONS = [
    { question: getMessages().getText('kanban-poll.question.requirements') },
    { question: getMessages().getText('kanban-poll.question.usage') },
    { question: getMessages().getText('kanban-poll.question.acceptability') },
];
